import React, { useEffect, useState, useRef } from 'react';
import Select from "react-select";
import { customFetch } from '../apiClient';

const PatientEditModal = ({ patientData, departments, onClose, onUpdate, entityType }) => {
  const initialForm = { 
    name: "", mobile: "", registrationDate: "", gender: "Male", age: "", ageIn: "Years", sendBy: "", 
    remarks: "", 
    title: "", email: "", careOf: "", relationWithPatient: "Father", careOfMobile: "", appointmentReason: "", 
    address: "", policeStation: "", city: "", state: "", pincode: "", 
    departmentId: "", doctorId: "", rmoId: "", referredBy: "", 
    weight: "", height: "", bp: "", oxygen: "", pulse: "", temperature: "", rbs: "", 
    consultFee: "", discount: "", payable: "", paid: "", paymentMode: "Cash", due: "", discountAuthority: "", requestedBy: "",
    packageId: "" // ✅ New Field for Package
  };

  // --- Static Options ---
  const titleOptions = [
    { value: "Mr", label: "Mr" }, { value: "Mrs", label: "Mrs" }, { value: "Miss", label: "Miss" },
    { value: "Ms", label: "Ms" }, { value: "Master", label: "Master" }, { value: "Baby", label: "Baby" }, { value: "Dr", label: "Dr" }
  ];
  const genderOptions = [
    { value: "Male", label: "Male" }, { value: "Female", label: "Female" }, { value: "Other", label: "Other" }
  ];
  const ageInOptions = [
    { value: "Years", label: "Years" }, { value: "Months", label: "Months" }, { value: "Days", label: "Days" }
  ];
  const relationOptions = [
    { value: "Father", label: "Father" }, { value: "Mother", label: "Mother" }, { value: "Spouse", label: "Spouse" },
    { value: "Sibling", label: "Sibling" }, { value: "Other", label: "Other" }
  ];
  const paymentModeOptions = [
    { value: "Cash", label: "Cash" }, { value: "UPI", label: "UPI" }, { value: "Card", label: "Card" }
  ];

  const titleGenderMap = { "Mr": "Male", "Master": "Male", "Mrs": "Female", "Miss": "Female", "Ms": "Female", "Baby": "Other", "Dr": "" };

  // --- State ---
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  
  const [discountAuthorities, setDiscountAuthorities] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [rmos, setRmos] = useState([]); 
  const [packages, setPackages] = useState([]); // ✅ Packages State
  
  const [selectedState, setSelectedState] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  
  const [deptOptions, setDeptOptions] = useState([]);
  const [docOptions, setDocOptions] = useState([]); 
  const [loadingAuthorities, setLoadingAuthorities] = useState(false);

  const [loadingMeta, setLoadingMeta] = useState({ states: false, districts: false, rmos: false, doctors: false, packages: false });
  const formRef = useRef(null);

 useEffect(() => {
    // 👇 YAHAN SE UPDATE HAI
    if (departments && departments.length > 0) {
      // Patient ka saved department ID nikaalo
      const currentDeptId = patientData?.departmentId ? Number(patientData.departmentId) : null;
      
      // Filter: Ya toh Active ho, YA FIR purana saved wala ho
      const filteredDepts = departments.filter(d => d.isActive === true || d.value === currentDeptId);
      
      setDeptOptions(filteredDepts);
    }
    
    const loadStates = async () => {
      try {
        setLoadingMeta(m => ({ ...m, states: true }));
        const res = await customFetch(`/District/states`);
        if (res.ok) {
          const data = await res.json();
          setStates(data.map(s => ({ value: s, label: s })));
        }
      } catch (err) { console.error(err); } finally { setLoadingMeta(m => ({ ...m, states: false })); }
    };


const loadAuthorities = async () => {
      try {
        setLoadingAuthorities(true);
        const res = await customFetch(`/DiscountAuthDt`);
        if (!res.ok) throw new Error("Failed");
        const data = await res.json();
        setDiscountAuthorities(data.map(a => ({ 
             value: a.id, 
             label: `${a.type}: ${a.authority}`,
             authName: a.authority // 👈 YAHAN ORIGINAL NAME BHI SAVE KAR LIYA
        })));
      } catch (err) { console.error(err); } 
      finally { setLoadingAuthorities(false); }
    };




    const loadRMOs = async () => {
      try {
        setLoadingMeta(m => ({ ...m, rmos: true }));
        const res = await customFetch(`/Employees/rmos`);
        if (res.ok) {
          const data = await res.json();
          setRmos(data.map(d => ({ value: d.id, label: d.name })));
        }
      } catch (err) { console.error(err); } finally { setLoadingMeta(m => ({ ...m, rmos: false })); }
    };

    const fetchDoctors = async () => {
      try {
        setLoadingMeta(m => ({ ...m, doctors: true }));
        const res = await customFetch(`/Employees/doctors`);
        if (res.ok) {
          const data = await res.json();
          setDocOptions(data.map(d => {
            let labelText = d.name;
            if (d.degree) labelText += ` (${d.degree})`;
            if (d.department?.departmentName) labelText += ` - ${d.department.departmentName}`;
            return { value: d.id, label: labelText };
          }));
        }
      } catch (err) { console.error(err); } finally { setLoadingMeta(m => ({ ...m, doctors: false })); }
    };

    // ✅ NEW: Fetch Active Packages (Only if entity is IPD)
    const fetchPackages = async () => {
      if (entityType !== "IPD") return; 
      try {
        setLoadingMeta(m => ({ ...m, packages: true }));
        const res = await customFetch(`/PackageMaster/active`);
        if (res.ok) {
          const data = await res.json();
          setPackages(data.map(p => ({ 
            value: p.id, 
            label: `${p.packageName} (₹${p.amount})`, 
            originalData: p 
          })));
        }
      } catch (err) { console.error(err); } finally { setLoadingMeta(m => ({ ...m, packages: false })); }
    };

    loadStates();
    loadAuthorities();
    loadRMOs();
    fetchDoctors(); 
    fetchPackages(); // Call it here
  }, [departments, entityType]);

  // --- 2. Populate Form Data ---
  useEffect(() => {
    if (patientData) {
      setForm({
        name: patientData.name || "", 
        mobile: patientData.mobileNo || "", 
        registrationDate: patientData.regDate ? patientData.regDate.split("T")[0] : "", 
        gender: patientData.gender || "Male", 
        age: patientData.age ? String(patientData.age) : "", 
        ageIn: patientData.ageIn || "Years", 
        sendBy: patientData.sendBy || "", 
        remarks: patientData.remarks || patientData.Remarks || "", 
        title: patientData.title || "", 
        email: patientData.emailId || "", 
        careOf: patientData.careOff || "", 
        relationWithPatient: patientData.relationWithPatient || "Father", 
        careOfMobile: patientData.alternateMobileNo || "", 
        appointmentReason: patientData.problems || "", 
        address: patientData.address || "", 
        city: patientData.city || "", 
        policeStation: patientData.policeStation || patientData.PoliceStation || "", 
        state: patientData.stateName || "", 
        pincode: patientData.pincode || "", 
        departmentId: patientData.departmentId ? Number(patientData.departmentId) : "", 
        doctorId: patientData.doctorId ? Number(patientData.doctorId) : "", 
        rmoId: patientData.rmoId || patientData.RmoId ? Number(patientData.rmoId || patientData.RmoId) : "", 
        referredBy: patientData.referedBy || "", 
        weight: patientData.weights || "", 
        height: patientData.heights || "", 
        bp: patientData.bp || "", 
        oxygen: patientData.oxy || "", 
        pulse: patientData.pulses || "", 
        temperature: patientData.temps || "", 
        rbs: patientData.rbs || patientData.RBS || "", 
        consultFee: patientData.consultFee ? String(patientData.consultFee) : "", 
        discount: patientData.discount ? String(patientData.discount) : "", 
        payable: patientData.payable ? String(patientData.payable) : "", 
        paid: patientData.received ? String(patientData.received) : "", 
        paymentMode: patientData.payMode || "Cash", 
        due: patientData.dues ? String(patientData.dues) : "",
       discountAuthority: patientData?.discountAuthId 
                   ? String(patientData.discountAuthId) 
                   : (patientData?.DiscountAuthId ? String(patientData.DiscountAuthId) : ""),
        // discountAuthority: patientData.authorisedBy || "", 
        requestedBy: patientData.disRequestBy || "",
        packageId: patientData.packageId || "" // ✅ Populate Package from Database if exists
      });

      if (patientData.stateName) setSelectedState({ value: patientData.stateName, label: patientData.stateName });
      if (patientData.city) setSelectedDistrict({ value: patientData.city, label: patientData.city });
    }
  }, [patientData]);

  // --- 3. Load Districts on State Change ---
  useEffect(() => {
    const loadDistricts = async () => {
      if (!selectedState) { setDistricts([]); return; }
      try {
        setLoadingMeta(m => ({ ...m, districts: true }));
        const res = await customFetch(`/District/districts?stateName=${encodeURIComponent(selectedState.value)}`);
        if (res.ok) {
          const data = await res.json();
          setDistricts(data.map(d => ({ value: d.district_Name, label: d.district_Name })));
        }
      } catch (err) { console.error(err); } finally { setLoadingMeta(m => ({ ...m, districts: false })); }
    };
    loadDistricts();
  }, [selectedState]);

  // --- 4. Keyboard Navigation ---
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== 'Enter') return;
      if (e.target.closest('.react-select__menu')) return;

      const focusableSelector = 'input:not([disabled]):not([type="hidden"]):not([readonly]), select:not([disabled]), textarea:not([disabled]):not([readonly]), button:not([disabled])';
      const focusableElements = Array.from(formRef.current?.querySelectorAll(focusableSelector) || []);

      if (focusableElements.length === 0) return;
      const currentIndex = focusableElements.indexOf(document.activeElement);

      if (currentIndex === focusableElements.length - 1) return; 

      if (currentIndex >= 0) {
        e.preventDefault(); 
        focusableElements[currentIndex + 1]?.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // --- Handlers ---
  const handleStateChange = (selected) => {
    setSelectedState(selected);
    setSelectedDistrict(null);
    setForm(prev => ({ ...prev, state: selected ? selected.value : "", city: "" }));
  };

  const handleDistrictChange = (selected) => {
    setSelectedDistrict(selected);
    setForm(prev => ({ ...prev, city: selected ? selected.value : "" }));
  };

  const handleSelectChange = (name, option) => {
    const value = option ? option.value : "";
    setForm(prev => {
      const newState = { ...prev, [name]: value };
      if (name === "title") newState.gender = titleGenderMap[value] || newState.gender;
      if (name === "departmentId") newState.doctorId = ""; 
      return newState;
    });
  };

const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => {
      const updated = { ...prev, [name]: value };

      // Agar inn teeno mein se koi bhi financial field change hoti hai
      if (["consultFee", "discount", "paid"].includes(name)) {
        
        // 1. Teeno ki current values lo (updated object se)
        const fee = Number(updated.consultFee || 0);
        const disc = Number(updated.discount || 0);
        const paidNum = Number(updated.paid || 0);

        // 2. Pehle naya Payable calculate karo
        const payable = Math.max(0, fee - (fee * disc) / 100);
        updated.payable = payable ? String(payable) : "";

        // 3. Ab us naye Payable ko use karke Due calculate karo
        const due = Math.max(0, payable - paidNum);
        updated.due = due > 0 ? String(due) : "0"; // "0" dena behtar hai empty chhodne se
      }

      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setSuccess("");

    if (!form.name || !form.mobile || !form.age) {
      setError("Please fill required fields (Name, Mobile, Age)");
      return;
    }

    if (form.discount && Number(form.discount) > 0 && !form.discountAuthority) {
      setError("Discount diya gaya hai, isliye Discount Authority select karna zaroori hai.");
      return;
    }

    try {
      setLoading(true);
   
      const idToUpdate = patientData.ipD_ID || patientData.opD_ID || patientData.opdId;
      const apiUrlBase = entityType === "IPD" ? `/Ipds` : `/Opds`;

      // Find the matched package object to get Name and Amount
      const selectedPkg = packages.find(p => String(p.value) === String(form.packageId))?.originalData;
// 👇 1. Selected Authority ko find karo
      const selectedAuth = discountAuthorities.find(a => String(a.value) === String(form.discountAuthority));


      const payload = {
        IPD_ID: patientData?.ipD_ID || patientData?.IPD_ID || null,
        OpdId: patientData?.opdId || patientData?.OpdId || null,
        OpdDate: new Date().toISOString(),
        IPD_Date: new Date().toISOString(),
        RegDate: form.registrationDate,

        Title: form.title,
        Name: form.name,
        MobileNo: form.mobile,
        Gender: form.gender,
        Age: Number(form.age) || null,
        AgeIn: form.ageIn,
        EmailId: form.email,
        CareOff: form.careOf,
        RelationWithPatient: form.relationWithPatient,
        AlternateMobileNo: form.careOfMobile,
        Address: form.address,
        PoliceStation: form.policeStation, 
        City: form.city,
        StateName: form.state,
        Pincode: form.pincode,
        DepartmentId: form.departmentId ? Number(form.departmentId) : null,
        DoctorId: form.doctorId ? Number(form.doctorId) : null,
        RmoId: form.rmoId ? Number(form.rmoId) : null, 
        ReferedBy: form.referredBy,
        Problems: form.appointmentReason,
        Bp: form.bp,
        Weights: form.weight,
        Heights: form.height,
        Oxy: form.oxygen,
        Pulses: form.pulse,
        Temps: form.temperature,
        Rbs: form.rbs,
        RBS: form.rbs, 
        AuthorisedBy: selectedAuth ? selectedAuth.authName : null, // Naam gaya
        DiscountAuthId: form.discountAuthority ? Number(form.discountAuthority) : null, // ID gayi

        ConsultFee: form.consultFee !== "" && form.consultFee != null ? parseFloat(form.consultFee) : 0,
        Discount: form.discount !== "" && form.discount != null ? parseFloat(form.discount) : 0,
        Payable: form.payable !== "" && form.payable != null ? parseFloat(form.payable) : 0,
        Received: form.paid !== "" && form.paid != null ? parseFloat(form.paid) : 0,
        Dues: form.due !== "" && form.due != null ? parseFloat(form.due) : 0,

        PayMode: form.paymentMode,
    
        DisRequestBy: form.requestedBy,
        SendBy: form.sendBy,
        Remarks: form.remarks,

        // Existing values preservations
        UHID_No: patientData?.uhiD_No || patientData?.UHID_No || null,
        IPD_SRNO: patientData?.ipD_SRNO || patientData?.IPD_SRNO || null,
        HID: patientData?.hiD || patientData?.HID || null,
        DIS_STS: patientData?.diS_STS ?? false,
        Amount: patientData?.amount || 0,
        DIS: patientData?.diS || 0,

        // ✅ NEW: IPD-specific Package Fields Sent to Backend
        PackageId: entityType === "IPD" && form.packageId ? Number(form.packageId) : null,
        PackageName: entityType === "IPD" && form.packageId ? (selectedPkg ? selectedPkg.packageName : patientData?.packageName || null) : null,
        PackageAmount: entityType === "IPD" && form.packageId ? (selectedPkg ? selectedPkg.amount : patientData?.packageAmount || null) : null,
      };
      
      const res = await customFetch(`${apiUrlBase}/${idToUpdate}`, { 
        method: "PUT", 
        body: JSON.stringify(payload) 
      });

      if (!res.ok) throw new Error(await res.text() || "Failed to update");

      setSuccess("Updated successfully!");
      onUpdate();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FIXED HEIGHTS
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '30px', 
      height: '30px', 
      fontSize: '12px', 
      borderRadius: '6px',
      borderColor: state.isFocused ? 'var(--theme-color, #0088cc)' : '#dde2e8',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(0, 0, 0, 0.05)' : 'none',
      '&:hover': { borderColor: 'var(--theme-color, #0088cc)' }
    }),
    valueContainer: (base) => ({
      ...base, padding: '0 8px', height: '28px', minHeight: '28px'
    }),
    input: (base) => ({ ...base, margin: '0', padding: '0' }),
    indicatorsContainer: (base) => ({ ...base, height: '28px' }),
    dropdownIndicator: (base) => ({ ...base, padding: '2px 6px' }),
    clearIndicator: (base) => ({ ...base, padding: '2px 6px' }),
    menu: (base) => ({
      ...base, zIndex: 99999, borderRadius: '6px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
    option: (base, state) => ({
      ...base, fontSize: '12px',
      backgroundColor: state.isSelected ? 'var(--theme-color, #0088cc)' : state.isFocused ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)' : 'white',
      color: state.isSelected ? 'white' : '#2c3e50', cursor: 'pointer',
      '&:active': { backgroundColor: 'var(--theme-color, #0088cc)' },
    }),
  };

  const hasDiscount = form.discount && Number(form.discount) > 0;
  if (!patientData) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <div className="patient-card">
          <div className="patient-header">
            <div className="header-left">
              <div className="header-icon"><i className="bi bi-pencil-square"></i></div>
              <div className="header-text">
                <h5>Edit Patient Details</h5>
                <p>Update patient information and appointment details</p>
              </div>
            </div>
            <button className="close-btn" onClick={onClose}><i className="bi bi-x-lg"></i></button>
          </div>

          <div className="patient-body">
            {error && <div className="alert-custom alert-danger"><i className="bi bi-exclamation-triangle-fill"></i> {error}</div>}
            {success && <div className="alert-custom alert-success"><i className="bi bi-check-circle-fill"></i> {success}</div>}
            
            <form ref={formRef} onSubmit={handleSubmit} className="patient-form">
              
              {/* ══ Row 1: Title | Name | Age | Age In | Gender | Mobile | Date ══ */}
              <div className="form-row row-personal">
                <div className="form-group">
                  <label><i className="bi bi-person-circle"></i> Title</label>
                  <Select options={titleOptions} value={titleOptions.find(o => o.value === form.title)} onChange={(o) => handleSelectChange("title", o)} styles={selectStyles} menuPortalTarget={document.body} />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-person"></i> Name <span className="required">*</span></label>
                  <input name="name" value={form.name} onChange={handleChange} className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-123"></i> Age <span className="required">*</span></label>
                  <input name="age" value={form.age} onChange={handleChange} type="number" className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-hourglass"></i> Age In</label>
                  <Select options={ageInOptions} value={ageInOptions.find(o => o.value === form.ageIn)} onChange={(o) => handleSelectChange("ageIn", o)} styles={selectStyles} menuPortalTarget={document.body} />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-gender-ambiguous"></i> Gender</label>
                  <Select options={genderOptions} value={genderOptions.find(o => o.value === form.gender)} onChange={(o) => handleSelectChange("gender", o)} styles={selectStyles} menuPortalTarget={document.body} />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-phone"></i> Mobile <span className="required">*</span></label>
                  <input name="mobile" value={form.mobile} onChange={handleChange} maxLength="10" className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-calendar-event"></i> Reg. Date</label>
                  <input name="registrationDate" value={form.registrationDate} onChange={handleChange} type="date" className="form-control-custom" disabled={loading} />
                </div>
              </div>

              {/* ══ Row 2: Care Of | Relation | Care Of Mobile | Email | Reason ══ */}
              <div className="form-row row-contact">
                <div className="form-group">
                  <label><i className="bi bi-person-lines-fill"></i> Care Of</label>
                  <input name="careOf" value={form.careOf} onChange={handleChange} className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-diagram-3"></i> Relation</label>
                  <Select options={relationOptions} value={relationOptions.find(o => o.value === form.relationWithPatient)} onChange={(o) => handleSelectChange("relationWithPatient", o)} styles={selectStyles} menuPortalTarget={document.body} />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-telephone"></i> C/o Mobile No</label>
                  <input name="careOfMobile" value={form.careOfMobile} onChange={handleChange} className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-envelope"></i> Email</label>
                  <input name="email" value={form.email} onChange={handleChange} className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-chat-left-text"></i> Reason/Problem</label>
                  <input name="appointmentReason" value={form.appointmentReason} onChange={handleChange} className="form-control-custom" />
                </div>
              </div>

              {/* ══ Row 3: Address | Police Station | State | District | Pincode ══ */}
              <div className="form-row row-address">
                <div className="form-group address-col">
                  <label><i className="bi bi-geo-alt"></i> Address</label>
                  <input name="address" value={form.address} onChange={handleChange} className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-shield-lock"></i> Police Station</label>
                  <input name="policeStation" value={form.policeStation} onChange={handleChange} placeholder="Thana" className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-pin-map"></i> State</label>
                  <Select options={states} value={selectedState} onChange={handleStateChange} placeholder="Select" isLoading={loadingMeta.states} styles={selectStyles} menuPortalTarget={document.body} />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-pin"></i> District</label>
                  <Select options={districts} value={selectedDistrict} onChange={handleDistrictChange} placeholder="Select" isLoading={loadingMeta.districts} isDisabled={!selectedState} styles={selectStyles} menuPortalTarget={document.body} />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-mailbox"></i> Pincode</label>
                  <input name="pincode" value={form.pincode} onChange={handleChange} maxLength="6" className="form-control-custom" />
                </div>
              </div>

              {/* ══ Row 4: Dept, RMO, Doctor (Wider), Referred By ══ */}
              <div className="form-row row-dept">
                <div className="form-group">
                  <label><i className="bi bi-grid"></i> Dept.</label>
                  <Select options={deptOptions} value={deptOptions.find(o => String(o.value) === String(form.departmentId)) || null} onChange={(o) => handleSelectChange("departmentId", o)} styles={selectStyles} menuPortalTarget={document.body} placeholder="Select" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-person-fill-add"></i> RMO</label>
                  <Select options={rmos} value={rmos.find(o => String(o.value) === String(form.rmoId)) || null} onChange={(o) => handleSelectChange("rmoId", o)} isLoading={loadingMeta.rmos} placeholder="Select RMO" isClearable styles={selectStyles} menuPortalTarget={document.body} />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-person-badge-fill"></i> Doctor</label>
                  <Select options={docOptions} value={docOptions.find(o => String(o.value) === String(form.doctorId)) || null} onChange={(o) => handleSelectChange("doctorId", o)} isLoading={loadingMeta.doctors} styles={selectStyles} menuPortalTarget={document.body} placeholder="Select" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-arrow-repeat"></i> Referred By</label>
                  <input name="referredBy" value={form.referredBy} onChange={handleChange} className="form-control-custom" />
                </div>
              </div>

              {/* ══ Row 5: Vitals ══ */}
              <div className="form-row row-vitals">
                <div className="form-group"><label><i className="bi bi-distribute-vertical"></i> Wt(kg)</label><input name="weight" value={form.weight} onChange={handleChange} className="form-control-custom" /></div>
                <div className="form-group"><label><i className="bi bi-arrows-vertical"></i> Ht(cm)</label><input name="height" value={form.height} onChange={handleChange} className="form-control-custom" /></div>
                <div className="form-group"><label><i className="bi bi-activity"></i> BP</label><input name="bp" value={form.bp} onChange={handleChange} className="form-control-custom" /></div>
                <div className="form-group"><label><i className="bi bi-wind"></i> Oxy (%)</label><input name="oxygen" value={form.oxygen} onChange={handleChange} className="form-control-custom" /></div>
                <div className="form-group"><label><i className="bi bi-heart"></i> Pulse</label><input name="pulse" value={form.pulse} onChange={handleChange} className="form-control-custom" /></div>
                <div className="form-group"><label><i className="bi bi-thermometer-half"></i> Temp</label><input name="temperature" value={form.temperature} onChange={handleChange} className="form-control-custom" /></div>
                <div className="form-group"><label><i className="bi bi-droplet-half"></i> RBS</label><input name="rbs" value={form.rbs} onChange={handleChange} className="form-control-custom" /></div>
              </div>

              {/* ══ Row 6: Payments & Requested By ══ */}
              <div className="form-row row-payment">
                <div className="form-group"><label className="text-primary"><i className="bi bi-cash-coin"></i> Fee</label><input name="consultFee" value={form.consultFee} onChange={handleChange} className="form-control-custom input-primary" /></div>
                <div className="form-group"><label><i className="bi bi-percent"></i> Disc</label><input name="discount" value={form.discount} onChange={handleChange} className="form-control-custom" /></div>
                <div className="form-group"><label><i className="bi bi-calculator"></i> Payable</label><input name="payable" value={form.payable} className="form-control-custom bg-light" readOnly /></div>
                <div className="form-group"><label className="text-success"><i className="bi bi-check-circle"></i> Paid</label><input name="paid" value={form.paid} onChange={handleChange} className="form-control-custom input-success" /></div>
                <div className="form-group"><label className="text-danger"><i className="bi bi-exclamation-circle"></i> Due</label><input name="due" value={form.due} className="form-control-custom input-danger" readOnly /></div>
                <div className="form-group">
                   <label><i className="bi bi-credit-card"></i> Pay Mode</label>
                   <Select options={paymentModeOptions} value={paymentModeOptions.find(o => o.value === form.paymentMode)} onChange={(o) => handleSelectChange("paymentMode", o)} styles={selectStyles} menuPortalTarget={document.body} />
                </div>
                <div className="form-group">
                   <label><i className="bi bi-person-workspace"></i> Req By</label>
                   <input name="requestedBy" value={form.requestedBy} onChange={handleChange} className="form-control-custom" />
                </div>
                <div className="form-group">
                   <label className="text-warning"><i className="bi bi-shield-check"></i> Auth</label>
                   <Select 
                     options={discountAuthorities} 
                     // 👇 YAHAN CHANGE HUA HAI (String comparison)
                     value={discountAuthorities.find(o => String(o.value) === String(form.discountAuthority)) || null} 
                     onChange={(o) => handleSelectChange("discountAuthority", o)} 
                     styles={selectStyles} 
                     menuPortalTarget={document.body} 
                     placeholder={hasDiscount ? "Required *" : "Opt"} 
                     isDisabled={!hasDiscount} 
                     isClearable 
                   />
                </div>
              </div>

              {/* ══ Row 7 (UPDATED): Package | Send By | Remarks ══ */}
              <div className={`form-row ${entityType === "IPD" ? "row-remarks-ipd" : "row-remarks-opd"}`}>
                
                {/* ✅ DYNAMIC PACKAGE DROPDOWN (ONLY VISIBLE FOR IPD) */}
                {entityType === "IPD" && (
                    <div className="form-group">
                      <label className="text-primary"><i className="bi bi-box-seam"></i> IPD Package</label>
                      <Select 
                        options={packages} 
                        value={packages.find(o => String(o.value) === String(form.packageId)) || null} 
                        onChange={(o) => handleSelectChange("packageId", o)} 
                        isLoading={loadingMeta.packages} 
                        placeholder="Select Package (Optional)" 
                        isClearable 
                        styles={selectStyles} 
                        menuPortalTarget={document.body} 
                      />
                    </div>
                )}

                <div className="form-group">
                  <label><i className="bi bi-truck"></i> Send By</label>
                  <input name="sendBy" value={form.sendBy} onChange={handleChange} placeholder="Ambulance" className="form-control-custom" />
                </div>
                <div className="form-group">
                  <label><i className="bi bi-card-text"></i> Remarks</label>
                  <input name="remarks" value={form.remarks} onChange={handleChange} placeholder="Enter any notes here..." className="form-control-custom" />
                </div>
              </div>

              <div style={{ height: '20px' }}></div>
            </form>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-reset" onClick={onClose} disabled={loading}><i className="bi bi-x-circle"></i> Cancel</button>
            <button type="submit" className="btn-submit" onClick={handleSubmit} disabled={loading}>{loading ? "Updating..." : "Update"}</button>
          </div>
        </div>
      </div>

      <style jsx>{`
        .modal-backdrop {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(0, 0, 0, 0.6); display: flex; justify-content: center; align-items: center;
          z-Index: 1050; backdrop-filter: blur(2px);
        }

        .modal-content {
          position: relative; width: 95%; max-width: 1000px;
          height: 90vh; background: white; border-radius: 12px; 
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
          display: flex; flex-direction: column;
          animation: slideDown 0.3s ease; overflow: visible;
        }

        @keyframes slideDown { from { opacity: 0; transform: translateY(-30px); } to { opacity: 1; transform: translateY(0); } }

        .patient-card { display: flex; flex-direction: column; height: 100%; width: 100%; }

        .patient-header {
          background: var(--theme-color, #0088cc); padding: 16px 24px; color: white;
          display: flex; justify-content: space-between; align-items: center; flex-shrink: 0;
          border-top-left-radius: 12px; border-top-right-radius: 12px;
        }
        .header-left { display: flex; align-items: center; gap: 10px; }
        .header-icon { width: 35px; height: 35px; background: rgba(255,255,255,0.2); border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
        .header-text h5 { margin: 0; font-size: 16px; font-weight: 600; }
        .header-text p { margin: 2px 0 0 0; opacity: 0.9; font-size: 13px; }
        .close-btn { background: transparent; border: none; color: white; font-size: 18px; cursor: pointer; opacity: 0.8; }
        .close-btn:hover { opacity: 1; }

        .patient-body {
          padding: 20px 24px; overflow-y: auto; flex: 1;
        }

        .form-actions {
          display: flex; justify-content: flex-end; gap: 10px; padding: 15px 24px;
          background: #f8f9fa; border-top: 1px solid #e0e6ed; flex-shrink: 0;
          border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;
        }

        .alert-custom { padding: 10px; border-radius: 6px; margin-bottom: 10px; font-size: 13px; display: flex; align-items: center; gap: 8px; }
        .alert-danger { background: #fff5f5; color: #c00; border: 1px solid #ffcccc; }
        .alert-success { background: #f0fff4; color: #006600; border: 1px solid #ccffcc; }

        .patient-form { display: flex; flex-direction: column; gap: 12px; }

        /* ════ CSS GRID LAYOUT MATCHING PATIENT REGISTER ════ */
        .form-row { display: grid; gap: 12px; align-items: end; }
        
        .row-personal { grid-template-columns: 0.5fr 2fr 0.5fr 0.7fr 1fr 1fr 1fr; }
        .row-contact  { grid-template-columns: 1.5fr 1fr 1fr 1fr 1.5fr; }
        .row-address  { grid-template-columns: 2.2fr 1fr 1fr 1fr 1fr; }
        .row-dept     { grid-template-columns: 1fr 1fr 2.4fr 1fr; }
        .row-vitals   { grid-template-columns: repeat(7, 1fr); }
        .row-payment  { grid-template-columns: 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1fr 1fr 1.2fr; }
        
        /* ✅ DYNAMIC REMARKS ROW */
        .row-remarks-opd  { grid-template-columns: 1fr 4fr; }
        .row-remarks-ipd  { grid-template-columns: 1.5fr 1fr 3fr; }

        .form-group { display: flex; flex-direction: column; gap: 4px; }
        
        .form-group label { font-size: 12px; font-weight: 500; color: #495057; display: flex; align-items: center; gap: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .form-group label i { color: var(--theme-color, #0088cc); }
        .required { color: #dc2626; }
        .text-primary { color: var(--theme-color, #0066aa) !important; }
        .text-success { color: #047857 !important; }
        .text-danger { color: #dc2626 !important; }
        .text-warning { color: #d97706 !important; }

        /* ✅ MATCHING HEIGHTS FOR ALL INPUTS */
        .form-control-custom {
          padding: 0 10px; font-size: 12px; border: 1px solid #dde2e8; border-radius: 6px;
          outline: none; width: 100%; transition: 0.2s; 
          height: 30px; line-height: 28px; box-sizing: border-box;
        }
        .form-control-custom:focus { border-color: var(--theme-color, #0088cc); box-shadow: 0 0 0 2px rgba(0,0,0,0.05); }
        .form-control-custom:disabled { background: #f8f9fa; cursor: not-allowed; }
        .bg-light { background: #f1f3f5 !important; }
        .input-primary { border-color: #90caf9; background: #e3f2fd; }
        .input-success { border-color: #a7f3d0; background: #d1f4e0; }
        .input-danger { border-color: #fecaca; background: #fee2e2; }

        .btn-reset { padding: 8px 16px; background: #fff; border: 1px solid #ddd; border-radius: 6px; color: #555; cursor: pointer; font-size: 13px; display: flex; align-items: center; gap: 5px; }
        .btn-reset:hover:not(:disabled) { background: #f9f9f9; }
        
        .btn-submit {
          padding: 8px 20px; background: var(--theme-color, #0088cc); color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 13px; font-weight: 500; display: flex; align-items: center; gap: 5px;
        }
        .btn-submit:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); box-shadow: 0 2px 5px rgba(0,0,0,0.1); }
        .btn-submit:disabled { opacity: 0.7; cursor: not-allowed; }

        /* Responsive Breakpoints */
        @media (max-width: 1199px) and (min-width: 900px) {
          .row-personal { grid-template-columns: 0.5fr 1.8fr 0.5fr 0.7fr 1fr 1fr 1fr; }
          .row-contact  { grid-template-columns: 1fr 1fr 1fr 1.5fr 1fr; }
          .row-address  { grid-template-columns: 2fr 1fr 1fr 1fr 1fr; }
          .row-dept     { grid-template-columns: 1fr 1fr 2fr 1fr; }
          .row-vitals   { grid-template-columns: repeat(5, minmax(0, 1fr)); }
          .row-payment  { grid-template-columns: repeat(4, minmax(0, 1fr)); }
          .row-remarks-opd { grid-template-columns: 1fr 4fr; }
          .row-remarks-ipd { grid-template-columns: 1.5fr 1fr 3fr; }
        }

        @media (max-width: 899px) and (min-width: 700px) {
          .row-personal { grid-template-columns: repeat(4, minmax(0, 1fr)); }
          .row-contact  { grid-template-columns: 1fr 1fr 1fr 1fr; }
          .row-address  { grid-template-columns: repeat(4, minmax(0, 1fr)); }
          .row-dept     { grid-template-columns: 1fr 1fr 2fr 1fr; }
          .row-vitals   { grid-template-columns: repeat(4, minmax(0, 1fr)); }
          .row-payment  { grid-template-columns: repeat(4, minmax(0, 1fr)); }
          .row-remarks-opd { grid-template-columns: 1fr 3fr; }
          .row-remarks-ipd { grid-template-columns: 1fr 1fr 2fr; }
          .address-col  { grid-column: span 2; }
        }

        @media (max-width: 699px) and (min-width: 500px) {
          .row-personal { grid-template-columns: repeat(3, minmax(0, 1fr)); }
          .row-contact  { grid-template-columns: 1fr 1fr 1fr; }
          .row-address  { grid-template-columns: repeat(3, minmax(0, 1fr)); }
          .row-dept     { grid-template-columns: 1fr 1fr 1fr; }
          .row-vitals   { grid-template-columns: repeat(3, minmax(0, 1fr)); }
          .row-payment  { grid-template-columns: repeat(3, minmax(0, 1fr)); }
          .row-remarks-opd { grid-template-columns: 1fr 2fr; }
          .row-remarks-ipd { grid-template-columns: 1fr 1fr; }
          .address-col  { grid-column: span 3; }
        }

        @media (max-width: 499px) {
          .patient-body { padding: 10px 12px; }
          .row-personal { grid-template-columns: 1fr 1fr; }
          .row-contact  { grid-template-columns: 1fr 1fr; }
          .row-address  { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .row-dept     { grid-template-columns: 1fr 1fr; }
          .row-vitals   { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .row-payment  { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .row-remarks-opd, .row-remarks-ipd { grid-template-columns: 1fr; }
          .address-col  { grid-column: span 2; }
          .form-group.col-span-2,
          .form-group.col-span-3  { grid-column: span 1; }
        }
      `}</style>
    </div>
  );
};

export default PatientEditModal;